import React, { useEffect } from 'react';
import { NavigateFunction, NavigateOptions, To, useNavigate } from 'react-router';
import { resolveAppPath } from '@/utils';

// Navigation service to allow navigation from outside React components like axios interceptors
let navigateRef: NavigateFunction | null = null;

const navigate = (to: To, options?: NavigateOptions) => {
  if (navigateRef) {
    navigateRef(to, options);
  } else {
    // Fallback if navigate isn't set yet
    // Only navigate if the URLs are different
    const path = resolveAppPath(to);
    if (path !== window.location.href.substring(window.location.origin.length))
      window.location.href = path;
  }
};

// Provider component to set up navigation reference
const NavigationProvider = ({ children }: { children: React.ReactNode }) => {
  const nav = useNavigate();
  useEffect(() => {
    navigateRef = nav;
  }, [nav]);
  return <>{children}</>;
};

export { navigate, NavigationProvider };
